<template>
  <b-modal
    id="modal_imporatacao_doc"
    ref="modal_imporatacao_doc"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    v-model="showModal"
  >
    <div class="col-md-12 col-sm-12">
      <label>Tipo do documento</label>
      <multiselect
        v-model="tpArquivoSelected"
        :options="optionsTpArquivo"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn @click="onStore()" variant="secondary" :disabled="isDisabled">
          Exportar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
import AvisoErros from '../components/AvisoErros'
export default {
  components: {
    AvisoErros,
  },
  props: {
    rota: ''
},
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      tpArquivoSelected: [],
      optionsTpArquivo: [],
      errors_array: [],
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      data: [],
      form: new Form({
        lay_id: "",
        carga_id: "",
        docs: []
      }),
      helpForm: new Form({
        recordCollection: [],
        docfisCollection: [],
        status: ""
      })
    };
  },
  watch: {
    tpArquivoSelected(obj) {
      this.form.lay_id = obj.value;
    }
  },

  mounted() {
    this.getLivGeral();
  },

  methods: {
    onExport(id) {
      this.isDisabled = false;
      this.loading = false;
      this.tpArquivoSelected = [];
      this.errors_array = [];
      this.modal_titulo = "Exportação de documento";
      this.modal_botao = "Exportar";
      this.modal_acao = "i";
      this.data = [];
      if(this.rota == "exportacaodocfiscal"){
        this.form.docs = id
      }else{
        this.form.carga_id = id;
        this.rota = "gestaocarga"
      }
      this.$refs.modal_imporatacao_doc.show();
    },

    getLivGeral() {
      this.helpForm
        .get("/api/importacaodocedi/jsonlistgeral")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.layout.forEach(obj => {
            this.optionsTpArquivo.push({ label: obj.descr, value: obj.lay_id });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },

    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post('/api/'+this.rota+'/notfis')
        .then(response => {
          new ReturnApi(response, this);
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    }
  }
};
</script>
